module.exports = __webpack_public_path__ + "images/emoji/camera.38e1db7408b12befbe7f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/camera.png
// module id = 9GG2
// module chunks = 24